import A from 'utils/metrics/analytic'

enum originMedic {
  WEBINAR_FUTURE = 'webinar_future',
}
// Фонд "ВБлагодарность", кнопка "Подробнее"
const A_o_helpMedic = (origin: originMedic) => {
  A.setEvent('pomoshmedikam_open', { origin })
}

export { A_o_helpMedic, originMedic }
